import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DataLayerAnalytics,
  setAdobeAnalytics
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import {
  DataLayerEventError,
  PageErrorData
} from '../../models/analytics/data-layer.constants';
import { ErrorDetails } from '../../models/api/content-api.interfaces';

@Injectable({ providedIn: 'root' })
export class DataLayerErrorService {
  getErrorDataForAnalytics(
    analyticsData: DataLayerAnalytics
  ): DataLayerAnalytics {
    return {
      ...analyticsData,
      error: [PageErrorData]
    };
  }

  getErrorEventDataForAnalytics(
    analyticsData: DataLayerAnalytics,
    error: HttpErrorResponse | ErrorDetails,
    message: string,
    eventName: string,
    type: string
  ): DataLayerAnalytics {
    const data = { ...analyticsData };
    delete data.page;
    return {
      ...data,
      event_detail: eventName,
      event: 'error',
      error: [
        {
          type,
          code:
            (error as HttpErrorResponse).status?.toString() ??
            (error as ErrorDetails).code,
          message: this.getErrorMessage(message, error),
          destination_url: DataLayerEventError.error?.[0]?.destination_url || ''
        }
      ]
    };
  }

  getErrorMessage = (
    message: string,
    error: HttpErrorResponse | ErrorDetails
  ) => {
    return message ? message : error.message ? error.message : '';
  };

  getErrorType(): string {
    return DataLayerEventError.error?.[0]?.type || '';
  }

  setErrorAnalytics(errorData: DataLayerAnalytics): void {
    setAdobeAnalytics(errorData);
  }
}
